import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import { ReleaseRef } from 'hooks/data/versions/types';
import { useResolvedRelease } from 'hooks/useVersionInfo';
import { isV4Release } from 'utilities/constants/versions';

import { FetchDatasetParams } from '../types';

import { DocumentationResponse } from './types';

const fetchDatasetDocumentation = async (params: FetchDatasetParams) => {
  const { data } = await api.get(`/spold/documentation`, { params });

  return data;
};

const useDatasetDocumentation = (id?: string, release?: ReleaseRef) => {
  const { version, system_model } = useResolvedRelease(release);
  return useQuery<DocumentationResponse, AxiosError>({
    queryKey: ['documentation', id, version, system_model],
    queryFn: () => fetchDatasetDocumentation({ dataset_id: id as string, version, system_model }),
    enabled: !isV4Release(version) && !!id,
    retry: false,
  });
};

export default useDatasetDocumentation;
